import React, { useState, useEffect } from 'react';
import * as Utils from "../src/utils";
import { serverHost } from "../src/config";


function DocumentFilterSelector(props) {

    const filterSelector = (
        <select className="ml-1" value={props.selectedFilter} onChange={e => props.setSelectedFilter(e.target.value)}>
            <option value="sign_date_asc">Parakstīts ↑</option>
            <option value="sign_date_desc">Parakstīts ↓</option>
            <option value="document_date_asc">Dokumenta datums ↑</option>
            <option value="document_date_desc">Dokumenta datums ↓</option>
        </select>

    );
    return filterSelector;



}

export default DocumentFilterSelector;